import moneyFlowCommon from './common';
import moneyFlowContribution from './contribution';
import moneyFlowProprietary from './proprietary'
import moneyFlowForeign from './foreign'

export default {
  moneyFlowCommon,
  moneyFlowContribution,
  moneyFlowProprietary,
  moneyFlowForeign,
}
